"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldChange = exports.AuditLogEntryTransport = void 0;
var audit_log_entry_transport_1 = require("./audit-log-entry-transport");
Object.defineProperty(exports, "AuditLogEntryTransport", { enumerable: true, get: function () { return audit_log_entry_transport_1.AuditLogEntryTransport; } });
var field_change_1 = require("./field-change");
Object.defineProperty(exports, "FieldChange", { enumerable: true, get: function () { return field_change_1.FieldChange; } });
//# sourceMappingURL=index.js.map